import apiClient from '../middleware/apiClient';
import { COTTON_CSP_INTERNET_USAGE, CSP_INTERNET_USAGE } from '../helpers/apis';
import cottonFlagManager from '../helpers/featureFlags/cotton';
import { callApiWithFallback } from '../helpers/apiFallback';
import { kibanaLog } from '../helpers/logger';

export const GET_INTERNET_USAGE = 'GET_INTERNET_USAGE';
export const GET_INTERNET_USAGE_SUCCESS = 'GET_INTERNET_USAGE_SUCCESS';
export const GET_INTERNET_USAGE_FAILURE = 'GET_INTERNET_USAGE_FAILURE';

function dispatchGetInternetUsage(endpoint = CSP_INTERNET_USAGE) {
  return {
    type: GET_INTERNET_USAGE,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetInternetUsageSuccess(internetUsage) {
  return {
    type: GET_INTERNET_USAGE_SUCCESS,
    payload: internetUsage,
  };
}

function dispatchGetInternetUsageFailure(error) {
  return {
    type: GET_INTERNET_USAGE_FAILURE,
    payload: error,
  };
}

export const getInternetUsage = () => async (dispatch) => {
  try {
    let response;
    const { isAptV1Enabled, internetUsageEnabled } = cottonFlagManager;

    if (isAptV1Enabled) {
      // Use APT V1 API (100% Kotlin)
      kibanaLog('cotton_internet_usage_api_called');
      response = await dispatch(dispatchGetInternetUsage(COTTON_CSP_INTERNET_USAGE)).payload;
    } else if (internetUsageEnabled) {
      // Try Cotton API, fallback to Ruby API
      response = await callApiWithFallback(
        dispatch,
        () => dispatchGetInternetUsage(COTTON_CSP_INTERNET_USAGE),
        () => dispatchGetInternetUsage(CSP_INTERNET_USAGE),
        'internet_usage',
      );
    } else {
      // Only call Ruby API
      response = await dispatch(dispatchGetInternetUsage(CSP_INTERNET_USAGE)).payload;
    }

    return dispatch(dispatchGetInternetUsageSuccess(response));
  } catch (error) {
    return dispatch(dispatchGetInternetUsageFailure(error));
  }
};
